import type { EnvConfig } from 'config';
import production from './production';

/** Staging Segment write key — previews must not send analytics to prod Segment. */
const PREVIEW_SEGMENT_KEY = 'VQDMbHw65jkXg4go8KmBnDiXzeAz7GiO';

const cfPreview: EnvConfig = {
  ...production,
  appKeys: {
    ...production.appKeys,
    segment: PREVIEW_SEGMENT_KEY,
  },
  robots: 'noindex,nofollow',
  signInUrl: '/preview-sign-in',
  skipTrackingScripts: true,
};

export default cfPreview;
